<div class="link-modal">
  <div class="modal-head">
    <div class="title-block">
      <h2>Share Timesheet View Link</h2>
      <p class="sub">Anyone with this link can view the timesheet.</p>
    </div>
    <button type="button" class="close-btn" (click)="close()" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="field">
      <label>Timesheet link</label>
      <div class="link-input-wrap">
        <input type="text" class="input-form" [value]="timesheetViewLink" readonly />
        <button type="button" class="btn btn-primary copy-btn"
          (click)="copyLink(timesheetViewLink)">
          <i class="bi bi-clipboard"></i>
          <span>Copy</span>
        </button>
      </div>
    </div>
  </div>
</div>
